export class User {
  constructor({
    uid,
    displayName,
    email,
    photoURL,
    bio,
    location,
    joinDate,
    following,
    followers,
    followRequests,
    pendingFollowRequests,
    participatingActivities,
    createdActivities,
    onboardingStep,
    onboardingData,
    phone,
    phoneVerified,
    birthday,
    interests,
    credits,
    badges,
    onboardingCompleted
  }) {
    this.uid = uid;
    this.displayName = displayName;
    this.email = email;
    this.photoURL = photoURL;
    this.bio = bio || '';
    this.location = location ? (
      typeof location === 'object' ? 
        {
          placeId: location.placeId || '',
          address: location.address || '',
          coordinates: location.coordinates || {
            latitude: location.location?.lat || location.lat,
            longitude: location.location?.lng || location.lng
          }
        } 
        : { address: location, placeId: '', coordinates: null }
    ) : null;
    this.joinDate = joinDate;
    this.following = following || [];
    this.followers = followers || [];
    this.followRequests = followRequests || [];
    this.pendingFollowRequests = pendingFollowRequests || [];
    this.participatingActivities = participatingActivities || [];
    this.createdActivities = createdActivities || [];
    this.onboardingStep = onboardingStep || 'welcome';
    this.onboardingData = onboardingData || {
      phone: '',
      phoneVerified: false,
      birthday: null,
      activities: [],
      location: null,
      photo: null
    };
    this.phone = phone || '';
    this.phoneVerified = phoneVerified || false;
    this.birthday = birthday || null;
    this.interests = interests || [];
    this.credits = credits || 0;
    this.badges = badges || [];
    this.onboardingCompleted = onboardingCompleted || false;
  }

  getFormattedLocation() {
    return this.location?.address || null;
  }
} 